(function () {
  var container = document.querySelector(".shopify-policy__container");
  if (!container) return;

  var titleEl = container.querySelector(".shopify-policy__title h1");
  var bodyEl = container.querySelector(".shopify-policy__body");
  if (!titleEl || !bodyEl) return;

  var title = titleEl.textContent.trim();
  var currentPath = window.location.pathname;

  var policyLinks = [
    { href: "/policies/privacy-policy", label: "Privacy policy" },
    { href: "/policies/refund-policy", label: "Refund policy" },
    { href: "/policies/terms-of-service", label: "Terms of service" },
    { href: "/policies/shipping-policy", label: "Shipping policy" },
    { href: "/policies/contact-information", label: "Contact information" },
  ];

  var navItems = policyLinks
    .map(function (link) {
      var active = currentPath === link.href ? " is-active" : "";
      var aria = currentPath === link.href ? ' aria-current="page"' : "";
      return (
        '<li><a href="' +
        link.href +
        '" class="ss-policies__nav-link' +
        active +
        '"' +
        aria +
        ">" +
        link.label +
        "</a></li>"
      );
    })
    .join("");

  var wrapper = document.createElement("section");
  wrapper.className = "ss-policies section-wrapper";
  wrapper.id = "ss-policy-page";
  wrapper.innerHTML =
    '<div class="ss-policies__hero ss-reveal">' +
    '<div class="ss-policies__hero-inner">' +
    '<p class="ss-policies__eyebrow">Legal</p>' +
    '<h1 class="ss-policies__title"></h1>' +
    '<p class="ss-policies__subhead">Transparency matters. Review our policies for orders, privacy, shipping, and returns.</p>' +
    "</div></div>" +
    '<div class="ss-policies__trust ss-reveal ss-reveal-delay-1" role="list" aria-label="Store highlights">' +
    '<span class="ss-policies__trust-item" role="listitem"><strong>★ 4.83</strong> Customer Rating</span>' +
    '<span class="ss-policies__trust-item" role="listitem"><strong>Free Shipping</strong> on All Orders</span>' +
    '<span class="ss-policies__trust-item" role="listitem"><strong>60-Day</strong> Money-Back Guarantee</span>' +
    '<span class="ss-policies__trust-item" role="listitem"><strong>Made in the USA</strong></span>' +
    "</div>" +
    '<div class="ss-policies__body"><div class="ss-policies__layout">' +
    '<aside class="ss-policies__nav ss-reveal ss-reveal-delay-1" aria-label="Policy navigation">' +
    '<p class="ss-policies__nav-label">All Policies</p>' +
    '<ul class="ss-policies__nav-list">' +
    navItems +
    "</ul>" +
    '<div class="ss-policies__help">' +
    '<p class="ss-policies__help-title">Need help?</p>' +
    '<p class="ss-policies__help-text">Questions about your order, a refund, or how we handle your data? Our support team is here for you.</p>' +
    '<a href="/pages/contact" class="ss-policies__help-link">Contact Support →</a>' +
    "</div></aside>" +
    '<article class="ss-policies__article ss-reveal ss-reveal-delay-2">' +
    '<div class="ss-policies__content rte"></div>' +
    "</article></div>" +
    '<div class="ss-policies__bottom-cta ss-reveal">' +
    "<p>Ready to try ADDY? Explore our best-selling formulas.</p>" +
    '<a href="/collections/energy-focus" class="ss-policies__bottom-link">Shop Best Sellers →</a>' +
    "</div></div></section>";

  container.replaceWith(wrapper);

  wrapper.querySelector(".ss-policies__title").textContent = title;
  wrapper.querySelector(".ss-policies__content").appendChild(bodyEl);

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var els = wrapper.querySelectorAll(".ss-reveal");

  if (reducedMotion) {
    els.forEach(function (el) {
      el.classList.add("ss-visible");
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("ss-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: "0px 0px -24px 0px" }
  );

  els.forEach(function (el) {
    observer.observe(el);
  });
})();
